import {RouterModule, Routes} from '@angular/router';
import {GetAllNetworkServersDetailComponent} from './get-all-network-servers-detail/get-all-network-servers-detail.component';
import {GetAllJoinServersDetailComponent} from './get-all-join-servers-detail/get-all-join-servers-detail.component';
import {GetAllNetworkServersComponent} from './get-all-network-servers/get-all-network-servers.component';
import {GetAllNetworkServerGroupsComponent} from './get-all-network-server-groups/get-all-network-server-groups.component';
import {GetAllNetworkServerGroupsDetailComponent} from './get-all-network-server-groups-detail/get-all-network-server-groups-detail.component';
import {GetAllJoinServersComponent} from './get-all-join-servers/get-all-join-servers.component';
import {RoamingCommunitiesComponent} from './roaming-communities/roaming-communities.component';
import {AdminUsersComponent} from "./admin/admin-users/admin-users.component";
import {CreateJoinServersComponent} from "./admin/create-join-servers/create-join-servers.component";
import {CreateNetworkServersComponent} from "./admin/create-network-servers/create-network-servers.component";
import {CreateNsGroupsComponent} from "./admin/create-ns-groups/create-ns-groups.component";
import {CreateRoamingPartnersComponent} from "./admin/create-roaming-partners/create-roaming-partners.component";
import {CreateRoamingCommunitiesComponent} from "./admin/create-roaming-communities/create-roaming-communities.component";
import {CreateRoamingCommunityMemberComponent} from "./admin/create-roaming-community-member/create-roaming-community-member.component";
import {EditRoamingCommunityComponent} from "./admin/edit-roaming-community/edit-roaming-community.component";
import {EditRoamingCommunityMemberComponent} from "./admin/edit-roaming-community-member/edit-roaming-community-member.component";
import {EditRoamingPartnersComponent} from "./admin/edit-roaming-partners/edit-roaming-partners.component";
import {EditActivationAgreementComponent} from "./admin/edit-activation-agreement/edit-activation-agreement.component";
import {AddServingJoinServerComponent} from "./admin/add-serving-join-server/add-serving-join-server.component";
import {AddServedNetworkServerComponent} from "./admin/add-served-network-server/add-served-network-server.component";
import {AddRfparamSetComponent} from "./admin/add-rfparam-set/add-rfparam-set.component";
import {RoamingAgreementPeeringsComponent} from "./admin/roaming-agreement-peerings/roaming-agreement-peerings.component";


export const routes: Routes = [
  { path: '', component: GetAllNetworkServersComponent },
  { path: 'all-network', component: GetAllNetworkServersComponent },
  { path: 'all-network/:filterSearch/:keywordSearch', component: GetAllNetworkServersComponent },
  { path: 'all-network-groups', component: GetAllNetworkServerGroupsComponent },
  { path: 'network-group/:virtId', component: GetAllNetworkServerGroupsDetailComponent },
  { path: 'all-join', component: GetAllJoinServersComponent },
  { path: 'all-join/:filterSearch/:keywordSearch', component: GetAllJoinServersComponent},
  { path: 'network/:virtId', component: GetAllNetworkServersDetailComponent },
  { path: 'join/:virtId', component: GetAllJoinServersDetailComponent },
  { path: 'admin-users', component: AdminUsersComponent },
  { path: 'create-join-servers', component: CreateJoinServersComponent },
  { path: 'edit-join-servers', component: CreateJoinServersComponent },
  { path: 'create-network-servers', component: CreateNetworkServersComponent},
  { path: 'edit-network-servers', component: CreateNetworkServersComponent},
  { path: 'create-ns-groups', component: CreateNsGroupsComponent},
  { path: 'create-roaming-partners', component: CreateRoamingPartnersComponent},
  { path: 'edit-roaming-partners', component: EditRoamingPartnersComponent},
  { path: 'edit-activation-agreement', component: EditActivationAgreementComponent},
  { path: 'add-served-network-server', component: AddServedNetworkServerComponent},
  { path: 'add-serving-join-server', component: AddServingJoinServerComponent},
  { path: 'add-rfparam-set', component: AddRfparamSetComponent},
  { path: 'create-roaming-communities', component: CreateRoamingCommunitiesComponent},
  { path: 'all-roaming-community', component: RoamingCommunitiesComponent},
  { path: 'roaming-community/:virtId', component: EditRoamingCommunityComponent},
  { path: 'create-roaming-community-member', component: CreateRoamingCommunityMemberComponent},
  { path: 'edit-roaming-community-member', component: EditRoamingCommunityMemberComponent},
  { path: 'roaming-agreement-peerings', component: RoamingAgreementPeeringsComponent}
];

export const appRoutingProviders: any[] = [
];

export const routing = RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' });
